import Link from "@/components/AppLink";

const BuyCrypto = () => {
  return (
    <section className="buy-crypto">
      <div className="overlay pt-120 pb-120">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="section-header text-center">
                <h2 className="title">Conversion rules you control</h2>
                <p>
                  Schedule recurring conversions after each payout, cap slippage,
                  and route proceeds to cold-storage partners. Every swap is
                  logged for accounting and tax prep.
                </p>
                <Link href="/index-9" className="cmn-btn">
                  Learn More
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BuyCrypto;
